var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"cwx-btn",class:{ 'cwx-btn--primary': this.primary, 
            'cwx-btn--flat': this.flat,
            'cwx-btn--primary-text-color': this.primaryTextColor,
            'cwx-btn--icon': this.icon,
            'cwx-btn--disabled': this.disabled },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }